import { useContext, useEffect, useRef } from 'react'
import { AppContext } from '../../contexts/AppContext'
import AppContextInterface from '../../contexts/AppContext/AppContextInterface'

const useWindowError = () => {
  const { logSplunk } = useContext(AppContext) as AppContextInterface
  const logSplunkRef = useRef(logSplunk)

  useEffect(() => {
    logSplunkRef.current = logSplunk
  }, [logSplunk])

  useEffect(() => {
    const handleError = (error: ErrorEvent) => {
      console.log('Global Error Caught:', error)
      const { message, filename, lineno, colno } = error
      logSplunkRef.current?.(message, { message, filename, lineno, colno })
      error.preventDefault() // Prevent "Uncaught (in promise)" warnings
    }

    const handlePromiseRejection = (event: PromiseRejectionEvent) => {
      console.log('Unhandled Promise Rejection:', event.reason)
      logSplunkRef.current?.(event.reason, { type: 'unhandledrejection' })
      event.preventDefault() // Prevent "Uncaught (in promise)" warnings
    }

    window.addEventListener('error', handleError)
    window.addEventListener('unhandledrejection', handlePromiseRejection)

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handlePromiseRejection)
    }
  }, [])

  return null // Hook doesn't return UI
}

export default useWindowError
